<template>
  <div class="header">
    <div v-if="user.is_geberit_pro" class="certified-user">
      <svg
        width="20"
        height="28"
        viewBox="0 0 20 28"
        fill="#ffa500"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.5082 15.529C5.04491 17.0563 7.16224 18 9.5 18C9.59135 18 9.68235 17.9986 9.77301 17.9957M3.5082 15.529C1.95907 13.9893 1 11.8567 1 9.5C1 4.80558 4.80558 1 9.5 1C14.1944 1 18 4.80558 18 9.5C18 11.4966 17.3116 13.3325 16.1591 14.7831M3.5082 15.529L1 24.8897L5.07092 23.2198L7.76148 26.7014L10.0986 17.9792M9.77301 17.9957L12.1057 26.7014L14.7963 23.2198L18.8672 24.8897L16.1591 14.7831M9.77301 17.9957C9.88206 17.9923 9.9906 17.9868 10.0986 17.9792M10.0986 17.9792C12.5517 17.8086 14.7182 16.597 16.1591 14.7831M13.9998 9.5C13.9998 11.9853 11.985 14 9.49977 14C7.01449 14 4.99977 11.9853 4.99977 9.5C4.99977 7.01471 7.01449 5 9.49977 5C11.985 5 13.9998 7.01471 13.9998 9.5Z"
          stroke="white"
        />
      </svg>
      <!-- <svg width="20" height="28" viewBox="0 0 20 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.5082 15.529C5.04491 17.0563 7.16224 18 9.5 18C9.59135 18 9.68235 17.9986 9.77301 17.9957M3.5082 15.529C1.95907 13.9893 1 11.8567 1 9.5C1 4.80558 4.80558 1 9.5 1C14.1944 1 18 4.80558 18 9.5C18 11.4966 17.3116 13.3325 16.1591 14.7831M3.5082 15.529L1 24.8897L5.07092 23.2198L7.76148 26.7014L10.0986 17.9792M9.77301 17.9957L12.1057 26.7014L14.7963 23.2198L18.8672 24.8897L16.1591 14.7831M9.77301 17.9957C9.88206 17.9923 9.9906 17.9868 10.0986 17.9792M10.0986 17.9792C12.5517 17.8086 14.7182 16.597 16.1591 14.7831M13.9998 9.5C13.9998 11.9853 11.985 14 9.49977 14C7.01449 14 4.99977 11.9853 4.99977 9.5C4.99977 7.01471 7.01449 5 9.49977 5C11.985 5 13.9998 7.01471 13.9998 9.5Z" stroke="#ffa500"/>
</svg>
 -->
      <!-- 
      <svg width="20" height="28" viewBox="0 0 20 28" fill="none" xmlns="http://www.w3.org/2000/svg" class="certified-user__icon">
<path d="M3.5082 15.529C5.04491 17.0563 7.16224 18 9.5 18C9.59135 18 9.68235 17.9986 9.77301 17.9957M3.5082 15.529C1.95907 13.9893 1 11.8567 1 9.5C1 4.80558 4.80558 1 9.5 1C14.1944 1 18 4.80558 18 9.5C18 11.4966 17.3116 13.3325 16.1591 14.7831M3.5082 15.529L1 24.8897L5.07092 23.2198L7.76148 26.7014L10.0986 17.9792M9.77301 17.9957L12.1057 26.7014L14.7963 23.2198L18.8672 24.8897L16.1591 14.7831M9.77301 17.9957C9.88206 17.9923 9.9906 17.9868 10.0986 17.9792M10.0986 17.9792C12.5517 17.8086 14.7182 16.597 16.1591 14.7831M13.9998 9.5C13.9998 11.9853 11.985 14 9.49977 14C7.01449 14 4.99977 11.9853 4.99977 9.5C4.99977 7.01471 7.01449 5 9.49977 5C11.985 5 13.9998 7.01471 13.9998 9.5Z" stroke="white"/>
</svg> -->

      <!-- <img src="../../assets/img/certified_badge.png" class="certified-user__icon"> -->
      Gratulujemy! Jesteś
      <strong>Certyfikowanym Instalatorem Geberit Pro.</strong><br />Korzystaj z
      dodatkowych benefitów.
    </div>
    <div class="container top">
      <div class="row">
        <div class="col col-4">
          <router-link :to="{ name: 'Dashboard' }" class="top__logo">
            <img src="../../assets/img/logo.png" alt="logo" width="126" />
          </router-link>
        </div>
        <div class="col col-8 text-right">
          <p class="top__user">
            Witaj,
            <router-link :to="{ name: 'Profile' }" class="top__user-profile">{{
              user.first_name + " " + user.last_name
            }}</router-link>
            /
            <a href="" class="top__user-profile" @click.prevent="logout"
              >Wyloguj</a
            >
          </p>
          <div class="top__notification">
            <b-dropdown
              variant="link"
              size="sm"
              no-caret
              right
              @show="getNotifications(1)"
              @hidden="resetNotifications"
            >
              <template slot="button-content">
                <a href="" class="top__notification-link">
                  <img src="../../assets/img/notification_icon.png" alt="" />
                  <div class="top__notificatios" v-if="notification.count">
                    {{ notification.count }}
                  </div>
                </a>
              </template>
              <div
                ref="notifications"
                class="top__notification-content"
                v-bind:class="{ pending: pagination.pending }"
              >
                <b-dropdown-item
                  v-for="item in notification.notifications"
                  :key="item.id"
                  v-if="notification.notifications.length > 0"
                >
                  <span style="font-size: 14px; font-weight: 600">{{
                    item.data.title
                  }}</span
                  ><br />
                  <span style="font-size: 12px">{{ item.data.content }}</span>
                </b-dropdown-item>
                <b-dropdown-item v-if="notification.notifications.length == 0">
                  <span style="font-size: 12px">brak powiadomień</span><br />
                </b-dropdown-item>
                <mugen-scroll
                  scroll-container="notifications"
                  :handler="getNotifications"
                  :handleOnMount="scroll.handleOnMount"
                  :should-handle="!scroll.pending"
                ></mugen-scroll>
              </div>
            </b-dropdown>
          </div>
          <div
            class="hamburger"
            @click="toggleMenu = !toggleMenu"
            :class="{ hamburger__close: toggleMenu }"
          >
            <div class="hamburger__icon">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fluid-container nav bar">
      <div class="container">
        <ul class="nav__links" :class="{ 'nav__links--collapsed': toggleMenu }">
          <router-link
            :to="{ name: 'Dashboard' }"
            tag="li"
            class="nav__link"
            @click.native="toggleMenu = false"
          >
            <a>Strona główna</a>
            <i class="nav__floor"></i>
          </router-link>
          <!-- <router-link :to="{name: 'Rules'}" tag="li" class="nav__link" @click.native="toggleMenu = false">
                  <a>Zasady programu</a>
                  <i class="nav__floor"></i>
                </router-link> -->
          <router-link
            :to="{ name: 'Invoices' }"
            tag="li"
            class="nav__link"
            @click.native="toggleMenu = false"
          >
            <a>Faktury</a>
            <i class="nav__floor"></i>
          </router-link>
          <router-link
            :to="{ name: 'Prizes' }"
            tag="li"
            class="nav__link"
            @click.native="toggleMenu = false"
          >
            <a>Nagrody</a>
            <i class="nav__floor"></i>
          </router-link>
          <router-link
            :to="{ name: 'Calendar' }"
            tag="li"
            class="nav__link"
            @click.native="toggleMenu = false"
            v-if="user.user_type_id != 5"
          >
            <a>Szkolenia</a>
            <i class="nav__floor"></i>
          </router-link>
          <router-link
            :to="{ name: 'NewsList' }"
            tag="li"
            class="nav__link"
            @click.native="toggleMenu = false"
          >
            <a>Aktualności</a>
            <i class="nav__floor"></i>
          </router-link>
          <router-link
            :to="{ name: 'Tools' }"
            tag="li"
            class="nav__link"
            @click.native="toggleMenu = false"
            v-if="
              allowedRoles.includes(user.user_type_id) || user.is_certyficated
            "
          >
            <a>Wypożyczalnia narzędzi</a>
            <i class="nav__floor"></i>
          </router-link>

          <!-- <router-link :to="{name: 'Quizes'}" tag="li" class="nav__link" @click.native="toggleMenu = false">
                  <a>Quizy</a>
                  <i class="nav__floor"></i>
                </router-link> -->
          <!-- <router-link :to="{name: 'Advices'}" tag="li" class="nav__link" @click.native="toggleMenu = false" v-if="user.is_certyficated">
                  <a>Porady prawne</a>
                  <i class="nav__floor"></i>
                </router-link> -->
          <router-link
            :to="{ name: 'Contracts' }"
            tag="li"
            class="nav__link"
            @click.native="toggleMenu = false"
          >
            <a>Umowy</a>
            <i class="nav__floor"></i>
          </router-link>
          <router-link
            :to="{ name: 'Categories' }"
            tag="li"
            class="nav__link"
            @click.native="toggleMenu = false"
          >
            <a>Dokumenty</a>
            <i class="nav__floor"></i>
          </router-link>
          <router-link
            :to="{ name: 'Contact' }"
            tag="li"
            class="nav__link"
            @click.native="toggleMenu = false"
          >
            <a>Kontakt</a>
            <i class="nav__floor"></i>
          </router-link>
          <li class="nav__link nav__link--mobile">
            <a href="" class="top__user-profile" @click.prevent="logout"
              >Wyloguj</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import AuthenticationService from "@/app/authentication/authentication.service";
import { store } from "@/app/store";

export default {
  name: "HeaderComponent",
  computed: {
    user() {
      return this.$store.state.user;
    },
    notification() {
      return this.$store.state.notification;
    },
  },
  data() {
    return {
      pagination: {
        current_page: 1,
      },
      scroll: {
        handleOnMount: false,
        pending: false,
      },
      toggleMenu: false,
      allowedRoles: [1, 2],
    };
  },
  methods: {
    /**
     * Logout user.
     *
     * @return {void}
     */
    logout: function () {
      AuthenticationService.logout();
    },

    /**
     * Get notifications.
     *
     * @param  {int} page
     * @return void
     */
    getNotifications(page) {
      let vm = this;
      page = page || ++vm.pagination.current_page || 1;

      if (page > vm.pagination.last_page) {
        vm.scroll.pending = true;
        return;
      }

      vm.pagination.page;
      vm.pagination.pending = vm.scroll.pending = true;

      Vue.axios({
        method: "get",
        url: "/notifications",
        params: {
          page: page,
          pagination: 5,
        },
      })
        .then((response) => {
          store.dispatch("setNotification", {
            count: response.data.data.unread_count,
            notifications: response.data.data.notifications,
          });

          vm.pagination = response.data.pagination;
          vm.scroll.pending = false;
          window.dispatchEvent(new Event("resize"));
        })
        .catch((error) => (vm.pagination.pending = vm.scroll.pending = false));
    },

    /**
     * Reset notifications.
     *
     * @return void
     */
    resetNotifications() {
      store.dispatch("setNotification", {
        count: 0,
        notifications: [],
        reset: true,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/app/home/HeaderComponent.vue